import { useState, useEffect } from 'react';
import { normalizeImageUrl } from '../../utils/image-url.utils';

export const usePreloadImage = (src?: string) => {
    const [sourceLoaded, setSourceLoaded] = useState<string | undefined>();

    useEffect(() => {
        if (!src) return;
        const normalizedSrc = normalizeImageUrl(src);
        if (!normalizedSrc) return;
        const img = new Image();
        img.src = normalizedSrc;
        img.onload = () => setSourceLoaded(normalizedSrc);
    }, [src]);

    return sourceLoaded;
};
